module.exports = __webpack_public_path__ + "img/language_color_24dp.06d1851a.svg";